import { render, staticRenderFns } from "./ListItemExternalId.vue?vue&type=template&id=8cfb8ca8"
import script from "./ListItemExternalId.vue?vue&type=script&lang=js"
export * from "./ListItemExternalId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports